import type { ReactNode } from 'react';
export function ErrorScreen({ message, children }: { message: string; children?: ReactNode }) {
  return <div className="form-screen form-screen-error">Error: {message}{children}</div>;
}
